/* Crossfades the images of a category card.
   Only runs while the card is on screen and the tab is in front, so a row of
   cards costs nothing once the shopper has scrolled past it. */

if (!customElements.get('category-card-media')) {
  class CategoryCardMedia extends HTMLElement {
    connectedCallback() {
      this.frames = Array.from(this.querySelectorAll('[data-ccm-frame]'));

      // One image, or the merchant turned rotation off: leave the first frame up.
      if (this.frames.length < 2 || this.hasAttribute('data-paused')) return;

      // Shoppers who asked for less motion get the first image, and nothing else.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) return;

      this.index = this.frames.findIndex((frame) => frame.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      this.interval = Number(this.dataset.interval) || 4000;
      this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => (entry.isIntersecting ? this.start() : this.stop()),
          { rootMargin: '100px' }
        );
        this.observer.observe(this);
      } else {
        this.start();
      }

      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    start() {
      if (this.timer || document.hidden) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      this.frames[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.frames.length;
      this.frames[this.index].classList.add('is-active');
    }
  }

  customElements.define('category-card-media', CategoryCardMedia);
}
